/* eslint-disable no-underscore-dangle, consistent-return, no-else-return */
import axios from 'axios';
import _ from 'lodash';
import xmlToJSON from 'xmltojson';
import { DEVICE, IDENTITY_KEY_NAME } from '@/constants';
import {
  nativeFunction,
  callNativeFunction,
  OS,
  getIdentity,
} from '@/utils/detectDevice';
import getApiPath from '@/config/api';

const appApiRoot = getApiPath();

const API_URL = `${appApiRoot}/library/`;
axios.defaults.baseURL = API_URL;
// axios.defaults.timeout = 1;
axios.defaults.timeout = 1000 * 30; // 30s请求超时时间
axios.defaults.responseType = 'json';
axios.defaults.retry = 4;
axios.defaults.retryDelay = 1000;

axios.interceptors.request.use(
  async (config) => {
    const token = getIdentity(IDENTITY_KEY_NAME.TOKEN);
    const headers = token
      ? {
        common: {
          'X-Requested-With': 'XMLHttpRequest',
          Authorization: `Bearer ${token}`,
        },
        'Content-Type': 'application/json',
      }
      : undefined;
    return { ...config, headers };
  },
  error => Promise.reject(error),
);

const resStatus = [200, 304, 400];
const checkCode = res => (
  (res && resStatus.includes(res.status))
    ? Promise.resolve(res)
    : undefined
);

axios.interceptors.response.use(
  response => checkCode(response),
  (err) => {
    // console.log(err);
    if (err.response && (err.response.status === 401 || err.response.status === 403)) {
      OS.TYPE !== DEVICE.PC && callNativeFunction(nativeFunction.LOGOUT)();
      return Promise.reject(err);
    }
    if (err.response && err.response.status === 422 && err.response.data.errors) {
      const fieldName = Object.keys(err.response.data.errors)[0];
      console.log(err.response.data.errors[fieldName[0]]);
      return Promise.reject(err);
    }

    const { config } = err;
    // If config does not exist or the retry option is not set, reject
    if (!config || !config.retry) return Promise.reject(err);

    // Set the variable for keeping track of the retry count
    config.__retryCount = config.__retryCount || 0;

    // Check if we've maxed out the total number of retries
    if (config.__retryCount >= config.retry) {
      // Reject with the error
      return Promise.resolve(JSON.stringify({ code: 408, data: {}, msg: 'timeout' }));
    }

    // Increase the retry count
    config.__retryCount += 1;

    // Create new promise to handle exponential backoff
    const backoff = new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, config.retryDelay || 1);
    });

    const { url } = config;
    config.url = url.replace(API_URL, '');
    // Return the promise in which recalls axios to retry the request
    return backoff.then(() => axios(config));
  },
);

/**
 * 对外提供的方法：apiGet/apiPost/apiDelete/apiPut
 */
const apiMethods = {
  apiGet(url, data) {
    return new Promise((resolve, reject) => {
      axios.get(url, { params: data }).then(
        (response) => {
          if (_.has(response, 'data')) {
            resolve(response.data);
          } else {
            resolve(response);
          }
        }, (error) => {
          reject(error);
        },
      );
    });
  },

  // apiGetXml(url) {
  //   return new Promise((resolve, reject) => {
  //     axios.get(url, { responseType: 'text' }).then(
  //       (response) => {
  //         debugger;
  //         resolve(xmlToJSON.parseString(response.data));
  //       }, (error) => {
  //         debugger;
  //         reject(error);
  //       },
  //     );
  //   });
  // },

  apiGetXml(url) {
    // const xmltext = new XMLHttpRequest();
    // xmltext.open('GET', url, false);
    // xmltext.send();
    // const xml = new XMLSerializer().serializeToString(xmltext.responseXML);
    // // console.log(xmlToJSON.parseString(xml));
    // return xmlToJSON.parseString(xml);
    const xhr = new XMLHttpRequest();
    let result = {};
    // 10秒超时
    this.timer = setTimeout(() => {
      xhr.abort(); // 请求中止
      result = { code: 408, data: {}, msg: 'timeout' };
      console.log('resultTimeOut------', result);
    }, 8000);
    xhr.open('GET', url, false);
    xhr.onreadystatechange = () => {
      if (xhr.readyState === 4) {
        clearTimeout(this.timer); // 取消等待的超时
        if (xhr.status === 200) {
          const xml = xhr.responseText;
          result = { code: xhr.status, data: xmlToJSON.parseString(xml) };
        } else {
          console.log('xhr------', xhr);
          console.log('xhr.status------', xhr.status);
          result = { code: xhr.status, data: {}, msg: '' };
        }
      }
    };
    xhr.send();
    return result;
  },

  apiPost(url, data) {
    return new Promise((resolve, reject) => {
      axios.post(url, data).then(
        (response) => {
          if (_.has(response, 'data')) {
            resolve(response.data);
          } else {
            resolve(response);
          }
        }, (error) => {
          reject(error);
        },
      );
    });
  },

  apiPut(url, data) {
    return new Promise((resolve, reject) => {
      axios.put(url, data).then(
        (response) => {
          if (_.has(response, 'data')) {
            resolve(response.data);
          } else {
            resolve(response);
          }
        }, (error) => {
          reject(error);
        },
      );
    });
  },

  apiPatch(url, data) {
    return new Promise((resolve, reject) => {
      axios.patch(url, data).then(
        (response) => {
          if (_.has(response, 'data')) {
            resolve(response.data);
          } else {
            resolve(response);
          }
        }, (error) => {
          reject(error);
        },
      );
    });
  },

  apiDelete(url, data) {
    return new Promise((resolve, reject) => {
      axios.delete(url, data).then(
        (response) => {
          if (_.has(response, 'data')) {
            resolve(response.data);
          } else {
            resolve(response);
          }
        }, (error) => {
          reject(error);
        },
      );
    });
  },
};

// window.axios = axios;

export default apiMethods;
